import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LogOutIcon, PlaneIcon } from 'lucide-react';
import { AdminLogin } from '../components/admin/AdminLogin';
import { StatsCards } from '../components/admin/StatsCards';
import { ResultsCharts } from '../components/admin/ResultsCharts';
import { VotesTable } from '../components/admin/VotesTable';
import { VoteDetailPanel } from '../components/admin/VoteDetailPanel';
import { ExportBar } from '../components/admin/ExportBar';
import { useVotes } from '../lib/useVotes';
import { isAuthed, signOut, getVotes, subscribe } from '../lib/store';
import type { Vote } from '../lib/types';
export function Admin() {
  const [authed, setAuthed] = useState<boolean>(() => isAuthed());
  const [selected, setSelected] = useState<Vote | null>(null);
  const [, force] = useState(0);
  const votes = useVotes();

  // Keep the detail panel's data in sync with realtime updates.
  useEffect(() => {
    return subscribe(() => {
      setSelected(cur => cur ? getVotes().find(v => v.id === cur.id) ?? null : null);
    });
  }, []);
  if (!authed) return <AdminLogin onSuccess={() => setAuthed(true)} data-id="element-351" data-mp="3fmvyg7r40djl" />;
  return <div className="min-h-screen w-full bg-slate-50" data-id="element-352" data-mp="3blsg9ella5f7">
      <header className="sticky top-0 z-30 border-b border-slate-100 bg-white/80 backdrop-blur print:static" data-id="element-353" data-mp="36oahui5778lg">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3" data-id="element-354" data-mp="31ph54rxqjlmc">
          <div className="flex items-center gap-2" data-id="element-355" data-mp="2wyh5vg158rgo">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-lavender-500 to-sky-500 text-white" data-id="element-356" data-mp="2wwnwhsz5bt4z">
              <PlaneIcon className="h-5 w-5" data-id="element-357" data-mp="2nxss8mfnwt4b" />
            </span>
            <div data-id="element-358" data-mp="2nzdku6if21zj">
              <h1 className="font-display text-lg font-700 leading-none text-slate-800" data-id="element-359" data-mp="2nvpvzknx23r5">
                Retreat Dashboard
              </h1>
              <p className="flex items-center gap-1 text-xs text-teal-500" data-id="element-360" data-mp="2e0ecyq5h6adl">
                <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-teal-500" data-id="element-361" data-mp="24c0rlb8jwtv8" />
                Live · updates in real time
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2" data-id="element-362" data-mp="1udt92nym63r4">
            <Link to="/" className="rounded-full px-3 py-2 text-sm font-600 text-slate-500 transition hover:text-lavender-600" data-id="element-363" data-mp="1uf4estbmdlkv">
              View vote page
            </Link>
            <button onClick={() => {
            signOut();
            setAuthed(false);
          }} className="inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-3 py-2 text-sm font-600 text-slate-700 transition hover:bg-slate-200" data-id="element-364" data-mp="2n4bmaht1xli9">
              <LogOutIcon className="h-4 w-4" data-id="element-365" data-mp="2i9fgmeuw6zmo" />
              Sign out
            </button>
          </div>
        </div>
      </header>

      <motion.main initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mx-auto max-w-6xl space-y-5 px-4 py-6" data-id="element-366" data-mp="3ascqjej76frv">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between" data-id="element-367" data-mp="zarc7ndqmj55">
          <div data-id="element-368" data-mp="ubn5d3eacxhz">
            <h2 className="font-display text-2xl font-700 text-slate-800" data-id="element-369" data-mp="ubwt0kbuyski">
              Dashboard Overview
            </h2>
            <p className="text-slate-500" data-id="element-370" data-mp="14310kyz7fb5b">Real-time results across all destinations.</p>
          </div>
          <ExportBar votes={votes} onRefresh={() => force(n => n + 1)} data-id="element-371" data-mp="gdgh8ez52bvi" />
        </div>

        <StatsCards votes={votes} data-id="element-372" data-mp="bf57e48ug1da" />
        <ResultsCharts votes={votes} data-id="element-373" data-mp="bg6qmw00ju63" />
        <VotesTable votes={votes} onSelect={setSelected} data-id="element-374" data-mp="bh85lbk5h0t3" />
      </motion.main>

      <VoteDetailPanel vote={selected} onClose={() => setSelected(null)} data-id="element-375" data-mp="pfzgkp3pu6d0" />
    </div>;
}